// extracted by mini-css-extract-plugin
export default {"ProfileInfo":"ProfileInfo_ProfileInfo__fr3Gm","ProfileInfo-dataItem":"ProfileInfo_ProfileInfo-dataItem__f+OAW"};